import { render, staticRenderFns } from "./ContactFieldsSettings.vue?vue&type=template&id=1874dfc8&scoped=true&"
import script from "./ContactFieldsSettings.vue?vue&type=script&lang=js&"
export * from "./ContactFieldsSettings.vue?vue&type=script&lang=js&"
import style0 from "./ContactFieldsSettings.vue?vue&type=style&index=0&id=1874dfc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1874dfc8",
  null
  
)

export default component.exports